/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable prettier/prettier */

// the require here is required because
type Icon = (props: JSX.IntrinsicElements['svg']) => JSX.Element;

export const Astronaut: Icon = require('./Astronaut.svg').default;
export const BackArrow: Icon = require('./BackArrow.svg').default;
export const CaretIcon: Icon = require('./Caret.svg').default;
export const CaretRightIcon: Icon = require('./CaretRight.svg').default;
export const CheckmarkCheckedIcon: Icon = require('./CheckmarkChecked.svg').default;
export const CheckmarkLockedIcon: Icon = require('./CheckmarkLocked.svg').default;
export const CheckmarkUncheckedIcon: Icon = require('./CheckmarkUnchecked.svg').default;
export const CloseIcon: Icon = require('./Close.svg').default;
export const ExternalLinkIcon: Icon = require('./ExternalLinkIcon.svg').default;
export const GridIcon: Icon = require('./Grid.svg').default;
export const HomeIcon: Icon = require('./Home.svg').default;
export const HourglassIcon: Icon = require('./Hourglass.svg').default;
export const HourglassEmptyIcon: Icon = require('./HourglassEmpty.svg').default;
export const InProgIcon: Icon = require('./InProgress.svg').default;
export const LeftArrow: Icon = require('./LeftArrow.svg').default;
export const LimitedIcon: Icon = require('./Limited.svg').default;
export const LinkIcon: Icon = require('./LinkIcon.svg').default;
export const ListIcon: Icon = require('./List.svg').default;
export const LockIcon: Icon = require('./LockIcon.svg').default;
export const MedalIcon: Icon = require('./Medal.svg').default;
export const RepeatIcon: Icon = require('./Repeat.svg').default;
export const RightArrow: Icon = require('./RightArrow.svg').default;
export const RocketIcon: Icon = require('./rocketIcon.svg').default;
export const RewardsIcon: Icon = require('./RewardsIcon.svg').default;
export const StarIcon: Icon = require('./Star.svg').default;
export const FilterIcon: Icon = require('./Filter.svg').default;
export const HeartIcon: Icon = require('./Heart.svg').default;
export const HeartFilledIcon: Icon = require('./HeartFilled.svg').default;
export const TimerThreeQuarters: Icon = require('./TimerThreeQuarters.svg').default;
export const TimerOneThird: Icon = require('./TimerOneThird.svg').default;
